import styles from './floatingMenuWrapper.module.scss'

type Props = {
  level: number
  nutralBorder: boolean
  style?: React.CSSProperties
  children?: React.ReactNode
  className?: string
}

const FloatingMenuWrapper = ({ style, children, level, nutralBorder, className }: Props) => {
  // Add more as needed
  let levelClassName = ''

  if (level === 0) levelClassName = styles.level0
  if (level === 1) levelClassName = styles.level1

  return (
    <div
      className={`
        ${styles.wrapper} 
        ${className}
        ${levelClassName}
        ${nutralBorder ? styles.nutralBorder : ''}
      `}
      style={style}>
      {children}
    </div>
  )
}

export default FloatingMenuWrapper
